import React from 'react';
import {
  HiShieldCheck,
  HiLocationMarker,
  HiHeart,
  HiClock,
  HiStar,
  HiLightBulb,
} from 'react-icons/hi';

const reasons = [
  {
    icon: HiShieldCheck,
    title: 'Trustworthy',
    description:
      'Your privacy and success are my priorities. I deliver on every promise with integrity and professionalism.',
  },
  {
    icon: HiLocationMarker,
    title: 'UK-Based Expertise',
    description:
      'Deep understanding of UK job markets, visa regulations, and professional standards from first-hand experience.',
  },
  {
    icon: HiHeart,
    title: 'Personalised Support',
    description:
      'Every client receives tailored guidance. No cookie-cutter solutions — only strategies designed for you.',
  },
  {
    icon: HiClock,
    title: 'Timely Delivery',
    description:
      'I respect your deadlines. All projects and services are delivered on time, every time.',
  },
  {
    icon: HiStar,
    title: 'Proven Results',
    description:
      'Hundreds of satisfied clients who have landed jobs, secured visas, and advanced their careers.',
  },
  {
    icon: HiLightBulb,
    title: 'Expert Guidance',
    description:
      'Stay informed with up-to-date knowledge of industry trends, visa policies, and career best practices.',
  },
];

const WhyChooseMe = () => {
  return (
    <section id="why-me" className="section-padding bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-primary font-medium text-sm tracking-wider uppercase">
            Why Choose Me
          </span>
          <h2 className="section-title mt-2">
            What Makes Me <span className="text-primary">Different</span>
          </h2>
          <p className="section-subtitle">
            I combine professional expertise with a personal touch to deliver
            results that truly matter.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="group text-center p-8 rounded-3xl hover:bg-soft-pink/30 transition-all duration-500 hover:shadow-lg"
            >
              <div className="w-16 h-16 bg-soft-pink rounded-2xl flex items-center justify-center mx-auto mb-5 group-hover:bg-primary group-hover:text-white transition-all duration-300">
                <reason.icon className="text-2xl text-primary group-hover:text-white transition-colors duration-300" />
              </div>
              <h3 className="text-lg font-display font-bold text-text-dark mb-3">
                {reason.title}
              </h3>
              <p className="text-text-light text-sm leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseMe;
